<template>
        <div class="site__body">
            <div class="block-space block-space--layout--after-header"></div>
            <div class="block">
                <div class="container container--max--lg">
                    <div class="row row-block">
                      <login></login>
                    </div>
                </div>
            </div>
            <div class="block-space block-space--layout--before-footer"></div>
        </div>   
</template>

<script>

import Login from './Login';
// import Register from './Register';

export default {
  // name: 'LoginRegister',
  components: {
    Login,
    // Register    
  }  
}
</script>

<style scoped>
.row-block {
  display: block !important;
  text-align: center;
}
</style>